import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useContext, useMemo, useState } from 'react';
import { UniversalDialog } from 'console/dialogs/universal';
import { Box, Button, Typography } from '@mui/material';
import { Z3KSettings } from '../../../provider/types';
import { SelectItemsPage } from './page-select-items';
import { useNavigate } from 'react-router';
import { useBooleanState } from 'shared/hooks/state/boolean';
export function useActionDialog() {
    const [opened, close, open] = useBooleanState(false);
    const ActionDialog = useMemo(() => {
        const ActionDialogComponent = ({ help_id, options, name_second_column, onChange: onChangeItems, onReject, ...props }) => {
            const navigate = useNavigate();
            const { service_view } = useContext(Z3KSettings);
            const [selected_items, setSelectedItems] = useState([
                //@ts-ignore
                ...props.value,
            ]);
            const _onConfirm = () => {
                //@ts-ignore
                onChangeItems(selected_items);
                close();
            };
            const onClickParentLink = useCallback((path) => {
                if (path) {
                    close();
                    navigate(`/settings/${path}`, {
                        state: { group_key: path, item_key: null, item_id: null },
                    });
                }
            }, [close]);
            const onClickChildLink = useCallback((parent_path, child_path, item_id) => {
                if (parent_path && child_path) {
                    close();
                    navigate(`/settings/${parent_path}/${child_path}`, {
                        state: {
                            group_key: parent_path,
                            item_key: child_path,
                            item_id: item_id,
                        },
                    });
                }
            }, [close]);
            const getFlagElement = useCallback((id) => {
                const flag = selected_items.findIndex((el) => el === id);
                return flag == -1 ? false : true;
            }, [selected_items]);
            return (_jsx(UniversalDialog, { open: opened, router: true, onClose: close, onBack: close, title: `Выберите ${name_second_column?.toLowerCase() ?? 'действия'}`, footer: service_view ? (_jsx(Button, { color: "primary", onClick: _onConfirm, variant: "contained", children: "\u041E\u043A" })) : (_jsx(_Fragment, {})), ...props, children: _jsx(Box, { display: "flex", flexDirection: "column", gap: 2, children: options.map((element, index) => {
                        const have_select_item = element.options.some((el) => getFlagElement(el.id));
                        if (!service_view && !have_select_item) {
                            return;
                        }
                        return (_jsxs(Box, { display: "flex", flexDirection: "column", children: [_jsxs(Box, { display: "flex", justifyContent: "space-between", alignItems: "center", children: [_jsx(Typography, { variant: "h6", color: "secondary.main", mr: 3, children: element.name }), element.url && (_jsx(Button, { size: "small", variant: "outlined", onClick: () => onClickParentLink(element?.url ?? null), children: _jsx(Typography, { variant: "caption", children: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 \u0440\u0430\u0437\u0434\u0435\u043B" }) }))] }), element.options.length > 0 ? (_jsx(SelectItemsPage, { parent_url: element.url, elements: element.options, selected: selected_items, onSelected: setSelectedItems, goChildLink: onClickChildLink }, `${element.name}-${index}-options`)) : (_jsx(Box, { ml: 2, mt: 1, children: _jsx(Typography, { variant: "subtitle2", children: "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439" }) }))] }, `${element.name}-${index}`));
                    }) }) }));
        };
        return ActionDialogComponent;
    }, [opened, close]);
    return [ActionDialog, open];
}
